/**
 * Generated by orval v7.5.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type DriveOnTaskDriverInputType = typeof DriveOnTaskDriverInputType[keyof typeof DriveOnTaskDriverInputType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DriveOnTaskDriverInputType = {
  UNKNOWN: 'UNKNOWN',
  DSO: 'DSO',
  EGS: 'EGS',
  ADHOC: 'ADHOC',
} as const;
